/* Busqueda predictiva compartida.
   La usan el buscador del header (escritorio y movil) y el de las paginas de
   coleccion. Cada input marcado con [data-search-input] tiene que vivir dentro
   de un .header-search-wrap que contenga tambien un .header-search-dropdown;
   de ahi sale el emparejamiento input -> dropdown. */
(function() {
  'use strict';
  var searchInputs = document.querySelectorAll('[data-search-input]');
  var allDropdowns = document.querySelectorAll('.header-search-dropdown');

  function dropdownFor(input) {
    var wrap = input.closest('.header-search-wrap');
    return wrap ? wrap.querySelector('.header-search-dropdown') : null;
  }

  /* Escapa para uso seguro tanto en atributos como en contenido HTML:
     sobre-escapar comillas/apostrofes en texto no afecta el render. */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function fetchSuggestions(query, dropdown) {
    var normalized = query.replace(/[._\-\s]/g, '');
    if (normalized.length < 2) { dropdown.classList.remove('active'); dropdown.innerHTML = ''; return; }
    dropdown.innerHTML = '<div class="hsd-loading">Buscando...</div>';
    dropdown.classList.add('active');

    var merged = [];
    var seen = {};
    var MAX = 5;

    function renderItem(p) {
      var imgSrc = esc(p.image || '');
      var imgHtml = imgSrc
        ? '<img class="hsd-img" src="' + imgSrc + '" alt="" loading="lazy">'
        : '<img class="hsd-img" src="data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22%23E5E7EB%22%3E%3Crect x=%223%22 y=%223%22 width=%2218%22 height=%2218%22 rx=%222%22/%3E%3C/svg%3E" alt="">';
      var idEscaped = esc(p.id);
      var urlEscaped = esc(p.url || '');
      var handleEscaped = esc(p.handle || '');
      var titleEscaped = esc(p.title || '');
      var skuEscaped = esc(p.sku || '');
      var brandEscaped = esc(p.vendor || '');
      var codFab = p.barcode || '';
      if (!codFab && p.title) {
        var comma = p.title.indexOf(',');
        if (comma > 0) codFab = p.title.substring(0, comma).trim();
      }
      if (!codFab) codFab = '—';
      var codFabEscaped = esc(codFab);
      /* El guion es relleno visual; en la cotizacion tiene que ir vacio. */
      var codFabDato = esc(codFab === '—' ? '' : codFab);
      return '<div class="hsd-item-wrap" data-id="' + idEscaped + '" data-title="' + titleEscaped + '" data-sku="' + skuEscaped + '" data-codfab="' + codFabDato + '" data-brand="' + brandEscaped + '" data-img="' + imgSrc + '" data-url="' + urlEscaped + '" data-handle="' + handleEscaped + '">'
        + '<a class="hsd-item" href="' + urlEscaped + '">'
        + imgHtml
        + '<div class="hsd-info">'
        + '<div class="hsd-title">' + titleEscaped + '</div>'
        + '<div class="hsd-meta">'
        + (skuEscaped ? '<span><span class="hsd-label">SKU:</span> ' + skuEscaped + '</span>' : '')
        + '<span><span class="hsd-label">Cod. Fabricante:</span> <span class="hsd-cf">' + codFabEscaped + '</span></span>'
        + (brandEscaped ? '<span><span class="hsd-label">Marca:</span> ' + brandEscaped + '</span>' : '')
        + '</div>'
        + '</div>'
        + '</a>'
        + '<button class="hsd-add" data-quote-add>Cotizar <span class="visually-hidden">' + titleEscaped + '</span></button>'
        + '</div>';
    }

    function render() {
      var limited = merged.slice(0, MAX);
      if (!limited.length) {
        dropdown.innerHTML = '<div class="hsd-empty">Sin resultados para "' + esc(query) + '"</div>';
        return;
      }
      var html = limited.map(renderItem).join('');
      html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="hsd-view-all">Ver todos los resultados</a>';
      dropdown.innerHTML = html;

      dropdown.querySelectorAll('[data-quote-add]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var wrap = this.closest('.hsd-item-wrap');
          if (!wrap) return;
          var id = wrap.dataset.id;
          var title = wrap.dataset.title;
          var sku = wrap.dataset.sku || '';
          var codfab = wrap.dataset.codfab || '';
          var brand = wrap.dataset.brand || '';
          if (typeof clmAddToCart === 'function') {
            var img = wrap.dataset.img || '';
            var url = wrap.dataset.url || '';
            clmAddToCart({ id: id, title: title, sku: sku, codfab: codfab, vendor: brand, image: img, url: url, qty: 1 });
            this.textContent = '✓';
            this.style.borderColor = '#22C55E';
            this.style.color = '#22C55E';
            setTimeout(function(el){ return function(){ el.textContent = 'Cotizar'; el.style.borderColor = ''; el.style.color = ''; }; }(this), 2000);
          }
        });
      });

      // Fetch missing images for products without one
      limited.forEach(function(p) {
        if (!p.image && p.handle) {
          fetch('/products/' + encodeURIComponent(p.handle) + '.json')
            .then(function(r) { return r.json(); })
            .then(function(d) {
              if (d.product && d.product.images && d.product.images.length) {
                var imgUrl = d.product.images[0].src;
                var wrap = dropdown.querySelector('.hsd-item-wrap[data-id="' + p.id + '"]');
                if (wrap) {
                  var img = wrap.querySelector('.hsd-img');
                  if (img) { img.src = imgUrl; }
                }
              }
            })
            .catch(function() {});
        }
      });

      // Fetch Cod. Fabricante desde los variants del producto o de la descripción
      limited.forEach(function(p) {
        if (!p.barcode && p.handle) {
          fetch('/products/' + encodeURIComponent(p.handle) + '.json')
            .then(function(r) { return r.json(); })
            .then(function(d) {
              if (d.product) {
                var codFab = '';
                var firstVar = d.product.variants && d.product.variants[0];
                if (firstVar && firstVar.barcode) codFab = firstVar.barcode;
                if (!codFab) {
                  /* products/<handle>.json trae body_html; "description" solo existe en el .js. */
                  var desc = d.product.body_html || d.product.description || '';
                  /* Cada etiqueta pasa a salto de linea para que el codigo termine en su </li> o </p>. */
                  var text = desc.replace(/<[^>]+>/g, '\n');
                  var match = text.match(/C(?:ó|o)digo\s*fabricante:\s*([^\n]+?)\s*(?:(?:Marca|Familia|Categoría|Código|Especificaciones):|$)/im);
                  if (match) codFab = match[1].trim().split(/[,;]/)[0].trim();
                }
                if (codFab) {
                  var wrap = dropdown.querySelector('.hsd-item-wrap[data-id="' + p.id + '"]');
                  var el = wrap && wrap.querySelector('.hsd-cf');
                  if (el) el.textContent = codFab;
                  /* Tambien en el dataset: de ahi lo lee el boton Cotizar, y si
                     solo se pinta el texto el codigo no llega al correo. */
                  if (wrap) wrap.dataset.codfab = codFab;
                }
              }
            })
            .catch(function() {});
        }
      });
    }

    // Phase 1: suggest.json (title search, has images)
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var suggestProducts = (data.resources && data.resources.results && data.resources.results.products) || [];
        suggestProducts.forEach(function(p) {
          if (!seen[p.id] && merged.length < MAX * 2) {
            seen[p.id] = true;
            merged.push({ id: p.id, title: p.title, handle: p.handle, url: p.url, vendor: p.vendor, sku: p.sku || '', barcode: p.barcode || '', image: p.image });
          }
        });
      })
      .catch(function() {})
      .then(function() {
        // Phase 2: search page
        return fetch('/search?q=' + encodeURIComponent(query) + '&type=product&options[prefix]=last')
          .then(function(r) { return r.text(); });
      })
      .then(function(html) {
        var m = html.match(/var meta = ({[^;]+});/);
        if (m) {
          try {
            var meta = JSON.parse(m[1]);
            (meta.products || []).forEach(function(p) {
              if (!seen[p.id]) {
                seen[p.id] = true;
                var v = p.variants && p.variants[0];
                merged.push({
                  id: p.id,
                  title: p.title || (v && v.name) || '',
                  handle: p.handle || '',
                  url: '/products/' + (p.handle || ''),
                  vendor: p.vendor || '',
                  sku: (v && v.sku) || '',
                  barcode: (v && v.barcode) || '',
                  image: null
                });
              } else {
                var v = p.variants && p.variants[0];
                var sku = (v && v.sku) || '';
                var barcode = (v && v.barcode) || '';
                if (sku) {
                  merged.forEach(function(m) { if (m.id == p.id && !m.sku) m.sku = sku; });
                }
                if (barcode) {
                  merged.forEach(function(m) { if (m.id == p.id && !m.barcode) m.barcode = barcode; });
                }
              }
            });
          } catch(e) {}
        }
        render();
      })
      .catch(function() {
        render();
      });
  }

  function hideAllDropdowns() {
    allDropdowns.forEach(function(d) { d.classList.remove('active'); });
  }

  searchInputs.forEach(function(inp) {
    /* El timer es por input: si fuera compartido, escribir en el buscador de la
       coleccion cancelaria la consulta pendiente del header. */
    var debounceTimer;
    inp.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var self = this;
      debounceTimer = setTimeout(function() {
        var dd = dropdownFor(self);
        if (dd) fetchSuggestions(self.value, dd);
      }, 350);
    });
    inp.addEventListener('focus', function() {
      if (this.value.length >= 2) {
        var dd = dropdownFor(this);
        if (dd) fetchSuggestions(this.value, dd);
      }
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.header-search-wrap')) hideAllDropdowns();
  });
})();
